import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  notificationButton: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: theme.typography.fontWeightSemiBold,
    textDecoration: 'none',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    fontSize: theme.typography.pxToRem(16),
    '& svg': {
      marginRight: theme.spacing(0.375),
      fontSize: theme.typography.pxToRem(24)
    },
    '& .MuiBadge-badge': {
      color: theme.palette.common.white
    },
    '&.active': {
      color: theme.palette.secondary.main
    }
  },
  notificationMobile: {}
}))
